import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { UserService } from '../../services/user.service';
import { UpdoxService } from '../../services/updox.service';
import { AlertService } from '../../_alert';

/**
 * Blocks the Secure Messaging page when the current practice has no active
 * Updox user provisioned. Surfaces the same contact-admin message used by the
 * disabled buttons and redirects to the practice dashboard, so a deep link
 * cannot bypass the gated entry points.
 */
@Injectable({ providedIn: 'root' })
export class SecureMessagingGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private updoxService: UpdoxService,
    private alertService: AlertService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.userService.secure_messaging_enabled) {
      return true;
    }

    this.alertService.info(this.updoxService.disabledMessage, { autoClose: true, keepAfterRouteChange: true });
    return this.router.createUrlTree(['/enterprise/home/dashboard']);
  }
}
